import styled from 'styled-components';
import { Card, TextField, Typography } from '@mui/material';
import ColoredHeader from '../../components/ColoredHeader';
import Button from '../../../components/Button';
import colors from '../../../styles/colors';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit_icon.svg';
import { ReactComponent as RegenerateIcon } from '../../../assets/icons/regenerate-icon.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled(Typography)`
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 30px;
`;

const GenerateButton = styled(Button)`
  padding: 40px;
  height: 40px;
  width: fit-content;
  font-size: 2 rem;
  line-height: 38px;
  border-radius: 5px;
  margin-bottom: 60px;
  background: ${colors.base.secondary2};
  color: ${colors.base.alpha};
  gap: 8px;
  border: 1px solid ${colors.shades.primary1};
  cursor: pointer;

  .MuiSvgIcon-root {
    color: ${colors.base.primary}
  }

  &:hover {
    background: ${colors.shades.dark5};
  }
`;

const CardContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  margin: -10px 30px 30px 30px;
  height: 100%;
  padding: 20px;
  z-index: 2;
  align-items: center;
  justify-content: center;
  position: relative;
  `;

const CardTitle = styled.div`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.35em
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledEditButton = styled(EditIcon)`
  height: 36px;
  width: 36px;
  margin-right: 5px;
  cursor: pointer;

  > path {
    stroke: ${colors.base.secondary2};
  }
`;

const StyledRegenerateButton = styled(RegenerateIcon)`
  height: 36px;
  width: 36px;
  margin-right: 16px;
  cursor: pointer;

  > path {
    stroke: ${colors.base.secondary2};
  }
`;

const SubTitle = styled(Typography)`
  margin: 60px 30px;
`;

const StyledHeader = styled(ColoredHeader)`
  &:after {
    height: 32px;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`;

const StyledTextField = styled(TextField)`
  margin: 20px 0px;
  width: 100%;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 60px;
  align-items: center;
`;

const ModalTitle = styled.div`
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.35em
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100px;
`;

export {
  Container,
  Title,
  CardContainer,
  CardTitle,
  CardHeader,
  StyledEditButton,
  SubTitle,
  StyledHeader,
  StyledTextField,
  OptionContainer,
  ModalContainer,
  ModalTitle,
  GenerateButton,
  ButtonContainer,
  StyledRegenerateButton,
};
